import {
  DEVICES_LAST_LOCATIONS_FETCH_STARTED,
  DEVICES_LAST_LOCATIONS_FETCH_SUCCEED,
  DEVICES_LAST_LOCATIONS_FETCH_FAILED,
  DEVICES_LAST_LOCATIONS_CLEAR
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  devices: [],
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case DEVICES_LAST_LOCATIONS_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case DEVICES_LAST_LOCATIONS_FETCH_SUCCEED:
      return { ...state, status: statuses.succeeded, devices: action.payload };
    case DEVICES_LAST_LOCATIONS_FETCH_FAILED:
      return { ...state, status: statuses.failed, error: action.error };
    case DEVICES_LAST_LOCATIONS_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
